<template>
  <Table :columns="columns" :data="rows" v-if="rows.length > 0" class="mt-2">
    <template #category="{ row, colspan }">
      <td class="full-row font-bold bg-purple-200 px-4 py-2 text-xl" :colspan="colspan">
        {{ row.category }}
      </td>
    </template>
    <template #duration="{ row, colspan }">
      <td class="full-row bg-purple-100 px-4 py-2 font-semibold" :colspan="colspan">
        {{ row.duration }}
      </td>
    </template>
  </Table>
  <Alert v-else>{{ $t("no_data") }}</Alert>
</template>

<script>
import { Table, Alert, formatPrice, formatPriceBand, formatTermLength } from "@estaly/ui";

export default {
  components: { Table, Alert },
  props: {
    breakdown: {
      type: Array,
      required: true,
    },
  },
  computed: {
    columns() {
      return [
        { field: "priceBand", label: "Prix du produit" },
        { field: "price", label: "Prix du contrat", numeric: true },
        { field: "commissionByContract", label: "Rémunération par vente", numeric: true },
        { field: "salesCount", label: "Nombre de ventes", numeric: true },
        { field: "totalCommission", label: "Commission totale", numeric: true },
      ];
    },
    rows() {
      return this.categories.map((category) => this.categoryRows(category)).flat();
    },
    categories() {
      return [...new Set(this.breakdown.map((item) => item.category))];
    },
    termLengths() {
      const terms = this.breakdown.filter((item) => !item.monthlyBilling);
      return [...new Set(terms.map((item) => item.termLength))].sort((a, b) => a - b);
    },
  },
  methods: {
    categoryRows(category) {
      const rows = [{ fullRow: true, slot: "category", category }];
      const data = this.breakdown.filter((item) => item.category === category);

      const monthlyRows = data
        .filter((item) => item.monthlyBilling)
        .map(this.row)
        .sort(this.sortRows);
      if (monthlyRows.length > 0) {
        rows.push({ fullRow: true, slot: "duration", duration: this.$t(`termLength.monthly`) });
        rows.push(...monthlyRows);
      }

      this.termLengths.forEach((termLength) => {
        const yearlyRows = data
          .filter((item) => !item.monthlyBilling && item.termLength === termLength)
          .map(this.row)
          .sort(this.sortRows);
        if (yearlyRows.length > 0) {
          rows.push({ fullRow: true, slot: "duration", duration: this.$t(`termLength.${termLength}_months`) });
          rows.push(...yearlyRows);
        }
      });

      return rows;
    },
    row(item) {
      return {
        category: item.category,
        priceBand: formatPriceBand(item),
        duration: formatTermLength(item),
        price: formatPrice(item.price),
        salesCount: item.salesCount,
        commissionByContract: formatPrice(item.commissionByContract),
        totalCommission: formatPrice(item.totalCommission),
      };
    },
    sortRows(a, b) {
      if (a.termLength === b.termLength) return a.priceBandMin - b.priceBandMin;
      return a.termLength - b.termLength;
    },
  },
};
</script>
